import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/EditSquare';
import {InputAdornment} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import { withStyles } from "@mui/styles";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import WorkIcon from "@mui/icons-material/Work";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
const headCells = [


 
  
  { id: 'us_name', numeric: false, label: 'Name' },
  { id: 'role', numeric: false, label: 'Role' },
  { id: 'us_phoneno', numeric: false, label: 'Phone No.' },
  { id: 'us_emailid', numeric: false, label: 'Emailid' },
   { id: '',  label: '' },
  ]
  
  

 
 function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Usermaster extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Userdata:[],usid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',roles:'',names:'',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   this.addUserboxRef = React.createRef();
	}
	
	updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage);  }
	

		componentWillMount() { 
		if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="User Management";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - User Management";
	

	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
}










  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxuser.php?action=getall&us_role='+this.state.roles+'&us_name='+this.state.names+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Userdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[10,20,50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Userdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage); });
   
 

  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)


    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      userDelete(usid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('us_id',usid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxuser.php", formData, {
        }).then(res => {
    
            
 
  this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }
	  userblock(usid,state){  
	let strmsg=" Block";
	
	if(state===0)
	{
		strmsg=" Unblock";
	}
let r = window.confirm("Do you really want to "+strmsg+"?");
 if(r === true){ 
 var formData = new FormData();
     formData.append('action','statusupdate')
	 formData.append('us_id',usid)
	 	 formData.append('us_isactive',state)   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxuser.php", formData, {
        }).then(res => {
    
    
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }

 Useraddbox(val){
        this.setState({ usid: val },()=>{this.addUserboxRef.current.handleClickOpen()});  
  
         

      }
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   


   <div className="searchmaster">


  
  <ul>
  

		
		<li>
 <p ><TextField className="inputcntlparent" size="small"
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
			 <li>
 	<p><FormControl  className="stadrp">			   
		<Select className="inputcntlparent" size="small"
		variant="outlined"
		native
		value={this.state.roles}
		onChange={this.myChangeHandler}
		name='roles'
		id='roles'
		placeholder="Role"
		InputLabelProps={{
		shrink: true,
		}}
		>
			<option value={0}>Select</option>
		<option value={1}>Super Admin</option>
		<option value={2}>Field Engineer</option>	
		</Select>
		</FormControl></p>	
</li>
<li>
<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button> <Button variant="contained" onClick={()=>{this.Useraddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button>	</p>
</li>
	</ul>
		
	
	
		
</div>		



<AddUserbox  ref={this.addUserboxRef} id={this.state.usid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Userdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Userdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.us_name}</TableCell>
<TableCell>{item.role}</TableCell>
<TableCell>{item.us_phoneno}</TableCell>
<TableCell>{item.us_emailid}</TableCell>

<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="editbtn" onClick={()=>{this.Useraddbox(item.us_id)}} endIcon={<EditIcon />}>

</Button>&nbsp;

 
 
{item.us_role !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="deletebtn" onClick={()=>{this.userDelete(item.us_id)}} endIcon={<DeleteIcon />}>
  
</Button> &nbsp;
 </React.Fragment>)}
 {item.us_isactive !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtnblock" onClick={()=>{this.userblock(item.us_id,1)}} endIcon={<PersonIcon />}>
  
</Button> &nbsp;
 </React.Fragment>)}
 {item.us_isactive !=='0' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtn" onClick={()=>{this.userblock(item.us_id,0)}} endIcon={<PersonOffIcon />}>
 
</Button> 
 </React.Fragment>)}
 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}
export class AddUserbox extends Component{
	
	constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,name:'',us_id:0,contactnumber:'',emailid:'',
      errormessage:'',erropen:false, passwords:'', txtpswd:'',
	  }
      
  }

 
Usergetdata() {

  if(this.props.id!==0)
  {
	 	
	   axios.get(Serverurl+'ajaxuser.php?action=getall&us_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      us_id:resp.data[0].us_id,
	  name: resp.data[0].us_name,
      contactnumber: resp.data[0].us_phoneno, 
		emailid: resp.data[0].us_emailid, 
role:resp.data[0].us_role, 	

     txtpswd:resp.data[0].us_password, 
   
    });
		
  }
  
});
	  
  }else{
	 this.setState({  
	  name:'',
	 emailid:'',
	 contactnumber:'',
	 us_id:0,
password:'',
	 
	  }); 
 }
  
    }
	 

	onclickclose = (e) => {
	 this.setState({open:false});
}


   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  name:'',emailid:'',contactnumber:'',passwords:'',role:'', 
     errormessage:'',erropen:false,
	  });
		this.Usergetdata();
		
	};
myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;

  if (nam === "contactnumber") {
    if (val === '' || re.test(val)) {
      this.setState({ [nam]: val });
    }
  }  else {
    this.setState({ [nam]: val });
  }
}


 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
	let role = this.state.role;
 let name = this.state.name;
 let contactnumber = this.state.contactnumber;
 let emailid = this.state.emailid;
 let passwords = this.state.passwords;

  


if(name==="")
{
	
	this.setState({errormessage:"Please Enter Name",erropen:true});
		 window.scrollTo({
          top: 0})
		 return false;
	
	
}


if(contactnumber==="")
{
	
	this.setState({errormessage:"Please Enter Contact Number",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(emailid==="")
{
	
	this.setState({errormessage:"Please Enter Username ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
else
{
	 if (!remail.test(emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
  }
}
if(passwords==="" && this.state.txtpswd==="")
{
	
	this.setState({errormessage:"Please Enter Password ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(role==="")
{
	
	this.setState({errormessage:"Please Select Role",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
   var formData = new FormData();
  
  
   if(this.state.us_id===0)
	  {
		  formData.append('us_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('us_id',this.state.us_id)
		
          }
	  
	  formData.append('action','insertorupdate') 
		
		formData.append('us_name',name)
		formData.append('us_phoneno',contactnumber)
		formData.append('us_emailid',emailid)
		formData.append('us_password',passwords)
		formData.append('us_role',role)	
		formData.append('userid',localStorage.getItem("VRuserid"))
		 
		axios.post(Serverurl+"ajaxuser.php", formData, {
        }).then(res => {
    if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Phone No. Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.onclickclose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> User Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
		<ul>
			  
						  
	<li><p> <span className="validation">*</span> Name</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.name}
			 
			 
			    slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 1
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <PersonIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}


    InputLabelProps={{ 
        shrink:true 
    }}
                          /></p></li>
		
	<li><p> <span className="validation">*</span> Phone Number</p>
	
	<p><TextField name="contactnumber" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.contactnumber}
			 
			  
		 slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 2
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
        <PhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
<li><p> <span className="validation">*</span> Email ID</p>						  
	<p><TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	     size="small"
	   value={this.state.emailid}
			 
			 
		 slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 3
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
       <EmailIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
	<li><p> <span className="validation">*</span> Password</p>						  
	<p><TextField name="passwords" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	     size="small"
	   value={this.state.passwords}
			type="password" 
			  
		  slotProps={{
    htmlInput: {
      maxLength: 15,
      tabIndex: 4
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={this.togglePassword} edge="end" sx={{ color: "#206ccc", fontSize: 20 }}>
            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p>	</li>	
<li>		
	 <p><span className="validation">*</span> Role</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.role}
		onChange={this.myChangeHandler}
		name='role'
		id='role'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Super Admin</option>
		<option value={2}>Field Engineer</option>
				
		</Select>
		</FormControl></p>	</li>							  
		
		
		
				
				


				
			  </ul>
		

		
		
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button className="frmsecondarybtn" onClick={this.onclickclose } color="secondary">
          Cancel
        </Button>
</div> 
<div className="savebtn">
        <Button className="frmPrimarybtn" onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
			 
 </div> 		
 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
}

 
  